import { render, staticRenderFns } from "./CodigosPrefacturasImport.vue?vue&type=template&id=a5edab50&scoped=true"
import script from "./CodigosPrefacturasImport.vue?vue&type=script&lang=js"
export * from "./CodigosPrefacturasImport.vue?vue&type=script&lang=js"
import style0 from "./CodigosPrefacturasImport.vue?vue&type=style&index=0&id=a5edab50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5edab50",
  null
  
)

export default component.exports